export default 'M8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m1 5a1 1 0 1 1-2 0V7.67a1 1 0 1 1 2 0zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0';